"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencyMap = void 0;
exports.getCurrencyByPattern = getCurrencyByPattern;
exports.getCurrencyByPatternByCountry = getCurrencyByPatternByCountry;
exports.getNumberV2 = getNumberV2;
exports.getNumberV2ByCountry = getNumberV2ByCountry;
exports.getNumberV2ByLocale = getNumberV2ByLocale;
exports.initBase = initBase;

var _ = require("../");

var _common = require("../common");

var currencyMap = {
  "AF": "AFN",
  "AX": "EUR",
  "AL": "ALL",
  "DZ": "DZD",
  "AS": "USD",
  "AD": "EUR",
  "AO": "AOA",
  "AI": "XCD",
  "AQ": "USD",
  "AG": "XCD",
  "AR": "ARS",
  "AM": "AMD",
  "AW": "AWG",
  "AU": "AUD",
  "AT": "EUR",
  "AZ": "AZN",
  "BS": "BSD",
  "BH": "BHD",
  "BD": "BDT",
  "BB": "BBD",
  "BY": "BYR",
  "BE": "EUR",
  "BZ": "BZD",
  "BJ": "XOF",
  "BM": "BMD",
  "BT": "BTN",
  "BO": "BOB",
  "BQ": "USD",
  "BA": "BAM",
  "BW": "BWP",
  "BV": "NOK",
  "BR": "BRL",
  "IO": "USD",
  "BN": "BND",
  "BG": "BGN",
  "BF": "XOF",
  "BI": "BIF",
  "CV": "CVE",
  "KH": "KHR",
  "CM": "XAF",
  "CA": "CAD",
  "KY": "KYD",
  "CF": "XAF",
  "TD": "XAF",
  "CL": "CLP",
  "CN": "CNY",
  "CX": "AUD",
  "CC": "AUD",
  "CO": "COP",
  "KM": "KMF",
  "CG": "XAF",
  "CD": "CDF",
  "CK": "NZD",
  "CR": "CRC",
  "CI": "XOF",
  "HR": "HRK",
  "CU": "CUP",
  "CW": "ANG",
  "CY": "EUR",
  "CZ": "CZK",
  "DK": "DKK",
  "DJ": "DJF",
  "DM": "XCD",
  "DO": "DOP",
  "EC": "USD",
  "EG": "EGP",
  "SV": "USD",
  "GQ": "XAF",
  "ER": "ERN",
  "EE": "EUR",
  "ET": "ETB",
  "FK": "FKP",
  "FO": "DKK",
  "FJ": "FJD",
  "FI": "EUR",
  "FR": "EUR",
  "GF": "EUR",
  "PF": "XPF",
  "TF": "EUR",
  "GA": "XAF",
  "GM": "GMD",
  "GE": "GEL",
  "DE": "EUR",
  "GH": "GHS",
  "GI": "GIP",
  "GR": "EUR",
  "GL": "DKK",
  "GD": "XCD",
  "GP": "EUR",
  "GU": "USD",
  "GT": "GTQ",
  "GG": "GBP",
  "GN": "GNF",
  "GW": "XOF",
  "GY": "GYD",
  "HT": "HTG",
  "HM": "AUD",
  "HN": "HNL",
  "HK": "HKD",
  "HU": "HUF",
  "IS": "ISK",
  "IN": "INR",
  "ID": "IDR",
  "IR": "IRR",
  "IQ": "IQD",
  "IE": "EUR",
  "IM": "GBP",
  "IL": "ILS",
  "IT": "EUR",
  "JM": "JMD",
  "JP": "JPY",
  "JE": "GBP",
  "JO": "JOD",
  "KZ": "KZT",
  "KE": "KES",
  "KI": "AUD",
  "KP": "KPW",
  "KR": "KRW",
  "KW": "KWD",
  "KG": "KGS",
  "LA": "LAK",
  "LV": "EUR",
  "LB": "LBP",
  "LS": "LSL",
  "LR": "LRD",
  "LY": "LYD",
  "LI": "CHF",
  "LT": "EUR",
  "LU": "EUR",
  "MO": "MOP",
  "MK": "MKD",
  "MG": "MGA",
  "MW": "MWK",
  "MY": "MYR",
  "MV": "MVR",
  "ML": "XOF",
  "MT": "EUR",
  "MH": "USD",
  "MQ": "EUR",
  "MR": "MRO",
  "MU": "MUR",
  "YT": "EUR",
  "MX": "MXN",
  "FM": "USD",
  "MD": "MDL",
  "MC": "EUR",
  "MN": "MNT",
  "ME": "EUR",
  "MS": "XCD",
  "MA": "MAD",
  "MZ": "MZN",
  "MM": "MMK",
  "NA": "NAD",
  "NR": "AUD",
  "NP": "NPR",
  "AN": "ANG",
  "NL": "EUR",
  "NC": "XPF",
  "NZ": "NZD",
  "NI": "NIO",
  "NE": "XOF",
  "NG": "NGN",
  "NU": "NZD",
  "NF": "AUD",
  "MP": "USD",
  "NO": "NOK",
  "OM": "OMR",
  "PK": "PKR",
  "PW": "USD",
  "PS": "EGP",
  "PA": "USD",
  "PG": "PGK",
  "PY": "PYG",
  "PE": "PEN",
  "PH": "PHP",
  "PN": "NZD",
  "PL": "PLN",
  "PT": "EUR",
  "PR": "USD",
  "QA": "QAR",
  "RE": "EUR",
  "RO": "RON",
  "RU": "RUB",
  "RW": "RWF",
  "SH": "SHP",
  "KN": "XCD",
  "LC": "XCD",
  "MF": "EUR",
  "PM": "EUR",
  "VC": "XCD",
  "WS": "WST",
  "SM": "EUR",
  "ST": "STD",
  "SA": "SAR",
  "SN": "XOF",
  "CS": "RSD",
  "SC": "SCR",
  "SL": "SLL",
  "SG": "SGD",
  "SK": "EUR",
  "SI": "EUR",
  "SB": "SBD",
  "SO": "SOS",
  "ZA": "ZAR",
  "GS": "FKP",
  "SS": "SSP",
  "ES": "EUR",
  "LK": "LKR",
  "SD": "SDG",
  "SR": "SRD",
  "SJ": "NOK",
  "SZ": "SZL",
  "SE": "SEK",
  "CH": "CHF",
  "SY": "SYP",
  "TW": "TWD",
  "TJ": "TJS",
  "TZ": "TZS",
  "TH": "THB",
  "TL": "USD",
  "TG": "XOF",
  "TK": "NZD",
  "TO": "TOP",
  "TT": "TTD",
  "TN": "TND",
  "TR": "TRY",
  "TM": "TMT",
  "TC": "USD",
  "TV": "AUD",
  "UG": "UGX",
  "UA": "UAH",
  "AE": "AED",
  "GB": "GBP",
  "US": "USD",
  "UM": "USD",
  "UY": "UYU",
  "UZ": "UZS",
  "VA": "EUR",
  "VU": "VUV",
  "VE": "VEF",
  "VN": "VND",
  "VG": "USD",
  "VI": "USD",
  "WF": "XPF",
  "EH": "MAD",
  "YE": "YER",
  "ZM": "ZMW",
  "ZW": "ZWL"
};
exports.currencyMap = currencyMap;

function initBase() {
  return new Promise(function (resolve, reject) {
    return resolve();
  });
}

function getCurrencyByPattern(num) {
  if (!_._locale) {
    throw Error("Elvish Error: please call init function with local parameter first");
  }

  if (!_._country) {
    throw Error("Elvish Error: please call init function with country parameter first");
  }

  var currency;
  var result;

  try {
    currency = _._apollo.currency[currencyMap[_._country]][_._locale] || _._apollo.currency[currencyMap[_._country]]["default"];
  } catch (e) {}

  if (currency) {
    result = currency.pattern.replace(/[#,.0]+/, /\.00/.test(currency.pattern) ? num.toLocaleString('en-US') + (num ? '' : '.00') : Math.round(num).toLocaleString('en-US'));
    if (num < 0) result = '-' + result.replace('-', '');
  } else {
    try {
      var ICU_locale = _._locale === "ar-EG" ? "ar-EG-u-nu-latn" : _._locale;
      result = Intl.NumberFormat(ICU_locale, {
        style: 'currency',
        currency: currencyMap[_._country]
      }).format(num);
    } catch (e) {}
  }

  return result;
} // 


function getCurrencyByPatternByCountry(num, country, locale) {
  console.log(country, locale, 'getCurrencyByPatternByCountry');

  if (!country) {
    console.log(country, 'countrycountry');

    if (!_._country) {
      throw Error("Elvish Error: please call getCurrencyByPatternByCountry function with country parameter first");
    } else {
      country = _._country;
    }
  }

  if (!locale) {
    if (!_._locale) {
      throw Error("Elvish Error: please call getCurrencyByPatternByCountry function with locale parameter first");
    } else {
      locale = _._locale;
    }
  }

  var currency;
  var result;

  try {
    currency = _._apollo.currency[currencyMap[country]][locale] || _._apollo.currency[currencyMap[country]]["default"];
  } catch (e) {}

  if (currency) {
    result = currency.pattern.replace(/[#,.0]+/, /\.00/.test(currency.pattern) ? num.toLocaleString('en-US') + (num ? '' : '.00') : Math.round(num).toLocaleString('en-US'));
    if (num < 0) result = '-' + result.replace('-', '');
  } else {
    try {
      var ICU_locale = locale === "ar-EG" ? "ar-EG-u-nu-latn" : locale;
      result = Intl.NumberFormat(ICU_locale, {
        style: 'currency',
        currency: currencyMap[country]
      }).format(num);
    } catch (e) {}
  }

  return result;
} // 配置里的NumberV2


function getNumberV2() {
  if (!_._locale) {
    throw Error("Elvish Error: please call init function with local parameter first");
  }

  return _._apollo.numberV2[_._locale] || _._apollo.numberV2["default"];
} // 配置里的NumberV2(按照传入的国家匹配)


function getNumberV2ByCountry(country) {
  var locale = (0, _common.getLocaleByCountry)(country);

  if (!locale) {
    locale = _._locale;
  }

  if (!locale) {
    throw Error("Elvish Error: please call getNumberV2ByCountry function with country parameter first");
  }

  return _._apollo.numberV2[locale] || _._apollo.numberV2["default"];
} // 配置里的NumberV2(按照传入的locale匹配)


function getNumberV2ByLocale(locale) {
  if (!locale) {
    locale = _._locale;
  }

  if (!locale) {
    throw Error("Elvish Error: please call getNumberV2ByCountry function with country parameter first");
  }

  return _._apollo.numberV2[locale] || _._apollo.numberV2["default"];
}